import React from 'react';
import { createRoot } from 'react-dom/client';
class TipView extends React.Component {

	constructor(props) {
		super(props);
		// console.log( props);
		 this.state = {
			id:  null,
			productId: null,
			productData: null
		}
		this.changeData.bind( this );
		this.hidePin.bind( this );
		this.hidePopup.bind( this );
	}
	componentDidMount() {
		 this.changeData();
	}
	hidePin( event ) {
		  event.stopPropagation();
		document.body.classList.remove('pin-body');

		// console.log(this);
		 console.log('eventhidepinnnnnn');
		 console.log(event);
		 console.log(this);
		document.querySelectorAll('.tooltip-box').forEach(function(el) {
			el.style.display = 'none';
			console.log('elllll');
			console.log( el );
		 });
	   
		 var tipboxes = document.querySelector('.project-popup');
		 var tipboxRoot = createRoot(tipboxes);
		 tipboxRoot.unmount();
		 tipboxes.innerHTML = "";
		 return false;
	}
	hidePopup( event ) {
		 console.log('eventttttt');
		 console.log(event);
		document.body.classList.remove('pin-body');
	var element = document.querySelector('.popup-product-detail');

	if (event.target != element &&  !element.contains(event.target) ) {
		

		var tipboxes = document.querySelector('.project-popup');
		 var tipboxRoot = createRoot(tipboxes);
		 tipboxRoot.unmount();
		tipboxes.innerHTML = "";
	  }
	}
	changeData( ) {
	   const requestOptions = {
		   method: 'GET',
		   headers: { 'Content-Type': 'application/json' },
		 /*  body: JSON.stringify({ productId: this.props.productId }) */
	   };
	   fetch("/hotspot/product-data?productId="+this.props.productId, requestOptions)
	   .then((res) => res.json())
	   .then((json) => {
		   this.setState({
			   productData: json,
			   DataisLoaded: true
		   });
		  // console.log(json);
		   return json.title;
	   })
	 }
    render() {
		var text = "";
		// console.log( this.state.productData);
		if( this.state.productData != null)
		{
			var downloadText = [];
			var iconImage = 	<svg xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink">
					<use xlinkHref="#download-pdf-icon0"> </use>
					<symbol id="download-pdf-icon0" viewBox="0 0 48 48">
						<path d="M41.4 12H32V2.6l9.4 9.4zM22.2 22.7c-.6 1.6-1.3 3.2-2.4 5.4-.6 1.1-1.2 2.1-1.7 3.1 2.9-1.2 6.1-2 9.1-2.6l-1.2-.9c-1.7-1.4-2.9-3.1-3.8-5zM43 14v31c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h23v12c0 .6.4 1 1 1h12zm-5.5 15.6c0-.3-.1-.6-.4-.9-.5-.5-1.8-.8-3.5-.8-1.3 0-2.9.1-4.6.3-.8-.4-1.6-.9-2.3-1.6-1.7-1.5-3-3.7-3.9-6.1.1-.2.1-.5.2-.7.2-1.1.4-4.6.4-4.6s-.7 2.7-.8 3.1c-.1.3-.2.5-.3.8-.5-1.8-.8-3.6-.8-5 0-.4 0-1.1.1-1.7.1-.4.2-.6.4-.7.3.1.7.6 1 1.4.3.7.3 1.5.3 2 0 0 .3-1.2.3-2 0-.4-.5-1.6-1.3-1.5h-.5c-.6 0-1.2.3-1.4.8-.5 2 .1 5.1 1.1 8.9l-.3.7c-.8 1.9-1.7 3.8-2.6 5.4-3.5 6.9-6.2 10.6-8.1 10.8v-.1c0-.9 1.5-3.1 3.7-4.8.2-.2 1.2-1.1 1.2-1.1s-1.3.7-1.6.9c-2.7 1.6-4 3.2-4.2 4.3-.1.3 0 .7.3.9l.7.3c1.9.9 4.2-1.5 7.2-6.9 3.1-1 7-2 10.5-2.5 3.2 1.8 6.8 2.7 8.2 2.3.3-.1.5-.3.7-.5.1-.2.3-.9.3-.9s-.3.4-.5.5c-.9.4-3.7-.3-6.5-1.7 2.5-.3 4.5-.3 5.6.1 1.4.4 1.4.9 1.4 1-.1.1 0-.3 0-.4z"></path>
					</symbol>
					</svg>;
			Object.keys(this.state.productData.downloadsFiles).forEach(key => {

				if( this.state.productData.downloadsFiles[key].icon == 'ies' )
				{
					iconImage =   <svg xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink">
								<use xlinkHref="#download-ies-icon"> </use>
								<symbol id="download-ies-icon" viewBox="0 0 48 48">
									<path d="M41 1H7c-1.1 0-2 .9-2 2v42c0 1.1.9 2 2 2h34c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-7 9.3c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm-5 0c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm-5 0c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm0 5c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm0 5c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm0 5c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm0 5c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm-5-20c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm-5 0c.7 0 1.2.6 1.2 1.2 0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.5-1.2 1.2-1.2zm23 26.1c-1.8 1.6-3.4.3-4.5-.7-1-.9-1.7-1.4-2.5-1.2-1 .3-1.3.9-1.7 1.6-.4.9-1 2-2.7 2.6-.1.2-.4.3-.6.3-.2 0-.5 0-.7-.1-.2 0-.4 0-.7.1-.2 0-.5-.1-.6-.3-1.8-.5-2.3-1.6-2.7-2.6-.4-.8-.6-1.4-1.7-1.6-.8-.2-1.5.3-2.5 1.2-1.1 1-2.7 2.3-4.5.7-1-.7-1.6-1.8-1.7-3.1-.4-5.9 7.9-15.6 9.7-17.2.3-.3.8-.3 1.1.1.3.3.3.8-.1 1.1-2.5 2.3-9.5 11.3-9.2 16 .1.9.4 1.6 1.1 2l.1.1c.8.7 1.2.5 2.6-.7 1-.9 2.2-1.9 3.9-1.5 1.7.5 2.2 1.6 2.6 2.5s.8 1.7 2.7 2c1.9-.2 2.2-1 2.7-2 .4-.9.9-2 2.6-2.5 1.6-.4 2.9.6 3.9 1.5 1.3 1.2 1.8 1.4 2.6.7l.1-.1c.7-.4 1-1.1 1.1-2 .4-4.7-6.7-13.8-9.2-16-.3-.3-.3-.8 0-1.1s.8-.3 1.1-.1c1.8 1.6 10.1 11.4 9.7 17.2-.4 1.3-.9 2.4-2 3.1z"/>
								</symbol>
								</svg>;
				}
				downloadText.push( <li> <a href={this.state.productData.downloadsFiles[key].fileURL} target="_blank">
				{iconImage}
				<span>{this.state.productData.downloadsFiles[key].fileName}</span> </a> 
				</li>);
			  });

			text = <div>
					<div className="popup-product-detail">
					<div className='close-pin' onClick={(event) => this.hidePin(event)} >X</div>
					<div className="popup-product-thumb"> 
					<a href={this.state.productData.url} target="_blank" ><img src={this.state.productData.imgURL} width="800" height="800" alt="Im01" data-txt="37734" /> </a> </div>
					<h3><a href={this.state.productData.url} target="_blank" >{this.state.productData.title} </a></h3>
					<h4>Downloads</h4>
						<ul className="popup-product-list">
						<li> <a href={'/products/pdf/'+this.state.productData.id} target="_blank">
							<svg xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink">
							<use xlinkHref="#download-pdf-icon"> </use>
							<symbol id="download-pdf-icon" viewBox="0 0 48 48">
								<path d="M41.4 12H32V2.6l9.4 9.4zM22.2 22.7c-.6 1.6-1.3 3.2-2.4 5.4-.6 1.1-1.2 2.1-1.7 3.1 2.9-1.2 6.1-2 9.1-2.6l-1.2-.9c-1.7-1.4-2.9-3.1-3.8-5zM43 14v31c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h23v12c0 .6.4 1 1 1h12zm-5.5 15.6c0-.3-.1-.6-.4-.9-.5-.5-1.8-.8-3.5-.8-1.3 0-2.9.1-4.6.3-.8-.4-1.6-.9-2.3-1.6-1.7-1.5-3-3.7-3.9-6.1.1-.2.1-.5.2-.7.2-1.1.4-4.6.4-4.6s-.7 2.7-.8 3.1c-.1.3-.2.5-.3.8-.5-1.8-.8-3.6-.8-5 0-.4 0-1.1.1-1.7.1-.4.2-.6.4-.7.3.1.7.6 1 1.4.3.7.3 1.5.3 2 0 0 .3-1.2.3-2 0-.4-.5-1.6-1.3-1.5h-.5c-.6 0-1.2.3-1.4.8-.5 2 .1 5.1 1.1 8.9l-.3.7c-.8 1.9-1.7 3.8-2.6 5.4-3.5 6.9-6.2 10.6-8.1 10.8v-.1c0-.9 1.5-3.1 3.7-4.8.2-.2 1.2-1.1 1.2-1.1s-1.3.7-1.6.9c-2.7 1.6-4 3.2-4.2 4.3-.1.3 0 .7.3.9l.7.3c1.9.9 4.2-1.5 7.2-6.9 3.1-1 7-2 10.5-2.5 3.2 1.8 6.8 2.7 8.2 2.3.3-.1.5-.3.7-.5.1-.2.3-.9.3-.9s-.3.4-.5.5c-.9.4-3.7-.3-6.5-1.7 2.5-.3 4.5-.3 5.6.1 1.4.4 1.4.9 1.4 1-.1.1 0-.3 0-.4z"></path>
							</symbol>
							</svg>
        					<span>Download Datasheet</span> </a>
					   </li>
			  			{downloadText}
    </ul>
    <a className="btn btn--primary" href={this.state.productData.url} target="_blank" >View Product</a>
  </div>
</div>
		}
        return (  <div className={'tip-content'} onClick={(event) => this.hidePopup(event)}  > {text}</div>  )
    }
}
export default TipView;